import { INTERCOM_API_BASE, INTERCOM_APP_ID } from './constants';

/**
 * Ends the identified Messenger session on logout so the next person on this browser doesn't inherit it,
 * then re-boots as an anonymous visitor. A later login upgrades the visitor via IntercomLoggedIn's 'update'.
 */
export function resetIntercom(): void {
  if (typeof window === 'undefined' || typeof window.Intercom !== 'function') {
    return;
  }
  delete window.intercomSettings;
  window.Intercom('shutdown');
  window.Intercom('boot', { api_base: INTERCOM_API_BASE, app_id: INTERCOM_APP_ID });
}
